<template>
    <div class="d-flex flex-column justify-content-center align-items-center">
        <div class="d-flex justify-content-center">
            <h2>Gerenciamento de artigos</h2>
        </div>
        <div class="col-12 col-md-10 col-lg-8 col-xl-6 px-0 mt-4">
            <div class="col-12 d-flex justify-content-center">
                <input type="text" 
                    class="col-6 form-control"
                    v-model="search"
                    placeholder="Pesquisa">
                <router-link
                    class="ml-5 btn btn-primary"
                    :to="{ name: 'NewArticle' }">
                    cadastrar
                </router-link>
            </div>
        </div>
        <div class="col-12 col-md-10 col-lg-8 col-xl-6  px-0 my-5">
            <DataTables
                v-model="articles"
                :headers="headers"
                :search="search"
                :tr-button="true"
                max_height="700px"
                @by-click-on-tr="Show"
                >

                <template v-slot:body="{ item }">
                    <td>
                        <b class="font-18">{{ item.titulo }}</b>
                    </td>
                    <td>
                        {{ ParseDate(item.created_at) }}
                    </td>
                    <td>
                        {{ ParseDate(item.updated_at) }}
                    </td>
                    <td v-if="item.author">
                        <b class="font-18">{{ item.author.nome }}</b>
                    </td>
                    <td>
                        <span
                            class="badge font-16 p-2"
                            :class="item.status == 3 ? 'badge-danger' : item.status == 1 ? 'badge-success' : 'badge-warning'
                            ">
                            {{ item.status == 3 ? 'inativo' : item.status == 1 ? 'ativo' : 'rascunho' }}
                        </span>
                    </td>
                </template>
            </DataTables>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DataTables from './../../shared/DataTables'

const _ = require('lodash')

export default {
    name: "ManageArticle",
    components: {
        DataTables
    },
    data () {
        return {
            articles:       [],
            headers:        [
                { text: 'Título', value: 'titulo', sortable: true },
                { text: 'Data criação', value: 'created_at', sortable: true },
                { text: 'Data edição', value: 'updated_at', sortable: true },
                { text: 'Autor', value: 'author.nome', sortable: true },
                { text: 'Visibilidade', value: 'status', sortable: true },
            ],
            search:         ""
        }
    },
    computed: {
        ...mapGetters('system', [
            'all_articles'
        ])
    },
    watch: {
        all_articles: {
            immediate: true,
            deep: true,
            handler(val)
            {
                this.articles = _.orderBy(val, 'updated_at', 'desc')
            }
        }
    },
    methods: {
        ...mapActions('system', [
            'GetFaqItems'
        ]),
        Show(article)
        {
            this.$router.push({ name: 'EditArticle', params: {
                article_id: article.id
            }})
        },
        ParseDate(date)
        {
            if(date)
            {
                let new_date = date.substr(0, 10).split('-').reverse().join('/')

                return new_date
            }
            return ''
        }
    },
    beforeMount()
    {
        this.GetFaqItems()
    }
}
</script>

<style>

</style>